// @flow

import { type PendingIncomingPayment } from './types';

export function getSafeSpeiUrl(incomingPayment: PendingIncomingPayment): string {
  const speiUrl = incomingPayment['spei_url'];
  if (!speiUrl)
    throw new Error('Spei: Invalid state - There is no spei_url property for this payment');

  return speiUrl;
}
